import React, {useEffect, useState} from "react";
import apiRequests from "../../Component/axios/config/config";
import WebLogo from "../../font & image/image/favicon.png";
import searchIcon from "../../font & image/image/search-normal.svg";
import toast from "react-hot-toast";
import Loading from "../../Component/Loading/Loading";
import {FaAngleLeft, FaAngleRight} from "react-icons/fa";
import {Pencil} from "lucide-react";
import {useNavigate} from "react-router-dom";


export default function AllBanners() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        setLoading(true);
        apiRequests.get(`/api/banner/get-all`)
            .then((response) => {
                setBanners(response.data.data);
                setCurrentIndex(0);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("Failed to get all banners");
                setBanners([]);
            })
            .finally(() => setLoading(false));
    }, []);


    return (
        <div className="grid gap-4 p-6">
            <div className="flex gap-4 items-center">
                <div className="text-3xl font-bold text-gray-800">
                    All Banners
                </div>
                <div className="flex flex-col sm:flex-row justify-between gap-4">
                    <div className="flex gap-2">
                        <button
                            onClick={() => navigate("edit-Banners")}
                            className="flex items-center bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg gap-2"
                        >

                            <Pencil className="w-4 h-4"/>
                            Edit Banner

                        </button>
                    </div>
                </div>
            </div>


            {loading ? (
                <Loading/>
            ) : (
                banners.length > 0 ? (
                    banners.map((banner, index) => (
                        index === currentIndex && (
                            <RenderBanners banner={banner} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex}
                                           bannerLength={banners.length}/>
                        )
                    ))
                    ) : (
                      <p className="w-full text-center text-xl text-gray-500 font-bold">
                          No banners found.
                      </p>
                )
            )}

        </div>
    );
}


function RenderBanners({banner, currentIndex, setCurrentIndex, bannerLength}) {


    return (
        <div className="relative">

            {!banner?.is_automatic && (
                <div className="mt-6 flex flex-col gap-8">
                    <div
                        className={`flex flex-col gap-[5.5rem] sm:gap-4 border border-gray-400 py-4 rounded-xl`}>
                        <nav className="flex justify-between items-center gap-2 px-12 py-6 sm:flex-row md:px-3">
                            <div className="flex gap-2 justify-center items-center">
                                <div
                                    className="text-[32px] flex items-center justify-centers text-buttonColor-shade8">
                                    <div
                                        className="flex flex-col gap-1.5 p-2 border-2 rounded-xl border-grey-shade9 bg-grey-shade9 sm:bg-transparent sm:border-transparent">
                                            <span
                                                className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                        <span
                                            className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                        <span
                                            className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                    </div>
                                </div>
                                <div className="text-4xl text-grey-shade9 font-extrabold md:hidden ">
                                    <img src={WebLogo} alt="goalafarin" className="w-24" height={42}
                                         width={42}/>
                                </div>
                            </div>
                            <div className="relative flex gap-3 w-1/2 sm:w-full">
                                <img
                                    width={20}
                                    height={20}
                                    src={searchIcon}
                                    alt=""
                                    className="sm:hidden absolute top-3 left-4"
                                />
                                <input
                                    className={`outline-none text-lg w-full border items-center bg-grey-shade3 border-grey-shade4 pl-14 py-2 rounded-xl sm:pl-3 sm:bg-transparent sm:border-grey-shade4 text-grey-shade5`}
                                    placeholder={"search Product"}
                                    readOnly
                                />
                            </div>
                            <div className="flex gap-2 justify-center items-center sm:hidden">
                                <div className="flex gap-3 items-center relative">
                                    <div
                                        className="relative w-full rounded-xl border transition-colors duration-300 bg-white border-black text-black text-xl flex items-center px-8 py-2 gap-2"
                                    >
                                        <div className="flex justify-between items-center w-full">
                                            En
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="w-fit px-4 py-2 text-center border-2 text-black text-xl bg-primary-shade6 border-primary-shade6 rounded-2xl"
                                >
                                    login / sign up
                                </div>
                            </div>
                        </nav>


                        <div
                            className="relative text-grey-shade1 flex justify-between w-full h-[414px] sm:w-[95%]  sm:rounded-[2rem] sm:mx-auto sm:h-48 sm:p-9">

                            <button
                                className={`z-50 absolute top-44 left-2 bg-gray-200 p-2 rounded-lg ${currentIndex === 0 && "opacity-30 cursor-not-allowed"}`}
                                onClick={() => {
                                    if (currentIndex !== 0) {
                                        setCurrentIndex(currentIndex - 1)
                                    }
                                }}
                                disabled={currentIndex === 0}
                            >
                                <FaAngleLeft className="text-black" size={40}/>
                            </button>

                            <img
                                src={banner.image ? `https://api.goalafarin.com${banner.image.path}` : "none"}
                                className="min-w-full"
                                alt=""
                            />

                            <button
                                className={`z-50 absolute top-44 right-2 bg-gray-200 p-2 rounded-lg ${bannerLength - 1 === currentIndex && "opacity-30 cursor-not-allowed"}`}
                                onClick={() => {
                                    if (bannerLength !== currentIndex) {
                                        setCurrentIndex(currentIndex + 1)
                                    }
                                }}
                                disabled={bannerLength - 1 === currentIndex}
                            >
                                <FaAngleRight className="text-black" size={40}/>
                            </button>

                        </div>


                    </div>

                </div>
            )}

            {banner?.is_automatic && (
                <div className="flex flex-col gap-8">
                    <div className={`flex flex-col gap-[5.5rem] rounded-xl sm:gap-4 border border-gray-400 py-4`}>
                        <nav className="flex justify-between items-center gap-2 px-12 py-6 sm:flex-row md:px-3">
                            <div className="flex gap-2 justify-center items-center">
                                <div className="text-[32px] flex items-center justify-centers text-buttonColor-shade8">
                                    <div
                                        className="flex flex-col gap-1.5 p-2 border-2 rounded-xl border-grey-shade9 bg-grey-shade9 sm:bg-transparent sm:border-transparent">
                                            <span
                                                className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                        <span
                                            className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                        <span
                                            className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                    </div>
                                </div>
                                <div className="text-4xl text-grey-shade9 font-extrabold md:hidden ">
                                    <img src={WebLogo} alt="goalafarin" className="w-24" height={42} width={42}/>
                                </div>
                            </div>
                            <div className="relative flex gap-3 w-1/2 sm:w-full">
                                <img
                                    width={20}
                                    height={20}
                                    src={searchIcon}
                                    alt=""
                                    className="sm:hidden absolute top-3 left-4"
                                />
                                <input
                                    className={`outline-none text-lg w-full border items-center bg-grey-shade3 border-grey-shade4 pl-14 py-2 rounded-xl sm:pl-3 sm:bg-transparent sm:border-grey-shade4 text-grey-shade5`}
                                    placeholder={"search Product"}
                                    readOnly
                                />
                            </div>
                            <div className="flex gap-2 justify-center items-center sm:hidden">
                                <div className="flex gap-3 items-center relative">
                                    <div
                                        className="relative w-full rounded-xl border transition-colors duration-300 bg-white border-black text-black text-xl flex items-center px-8 py-2 gap-2"
                                    >
                                        <div className="flex justify-between items-center w-full">
                                            En
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="w-fit px-4 py-2 text-center border-2 text-black text-xl bg-primary-shade6 border-primary-shade6 rounded-2xl"
                                >
                                    login / sign up
                                </div>
                            </div>
                        </nav>

                        <div
                            style={{backgroundImage: `url(https://api.goalafarin.com${banner?.cover?.path})`}}
                            className={`relative text-grey-shade1 flex justify-between px-12 w-full h-[414px] sm:w-[95%] bg-cover bg-no-repeat sm:bg-[linear-gradient(110.4deg,#FF731A_0%,#FF731A_20%,#FFD0B3_150%)] sm:rounded-[2rem] sm:mx-auto sm:h-48 sm:p-9`}>
                            <button
                                className={`z-50 absolute top-44 left-2 bg-gray-200 p-2 rounded-lg ${currentIndex === 0 && "opacity-30 cursor-not-allowed"}`}
                                onClick={() => {
                                    if (currentIndex !== 0) {
                                        setCurrentIndex(currentIndex - 1)
                                    }
                                }}
                                disabled={currentIndex === 0}
                            >
                                <FaAngleLeft className="text-black" size={40}/>
                            </button>

                            <div
                                className="flex flex-col sm:items-center sm:justify-center py-24 gap-10 pl-24 w-[50%] sm:p-0 md:w-full md:pl-4 md:pt-32 sm:gap-5">
                                <h3 className="flex justify-start w-full text-[48px] font-bold sm:text-xl">
                                    {banner.header}
                                </h3>
                                <p className="w-full text-lg sm:text-[12px] sm:leading-4">
                                    {banner.body}
                                </p>
                            </div>
                            {banner.image &&
                                <div className="w-[40%] sm:w-[100%] flex items-center justify-center -mr-10">
                                    <img
                                        width={400}
                                        height={580}
                                        src={banner.image ? `https://api.goalafarin.com${banner.image.path}` : "none"}
                                        alt=""
                                    />
                                </div>
                            }

                            <button
                                className={`z-50 absolute top-44 right-2 bg-gray-200 p-2 rounded-lg ${bannerLength - 1 === currentIndex && "opacity-30 cursor-not-allowed"}`}
                                onClick={() => {
                                    if (bannerLength - 1 !== currentIndex) {
                                        setCurrentIndex(currentIndex + 1)
                                    }
                                }}
                                disabled={bannerLength - 1 === currentIndex}
                            >
                                <FaAngleRight className="text-black" size={40}/>
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}